import { render, staticRenderFns } from "./RecentPublications.vue?vue&type=template&id=602ac63b&scoped=true&"
import script from "./RecentPublications.vue?vue&type=script&lang=js&"
export * from "./RecentPublications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602ac63b",
  null
  
)

export default component.exports